module.exports = __webpack_public_path__ + "static/media/bubble.9a2f64f8.png";